<template>
    <div class="form-group search-input">
        <i class="icon-search"></i>
        <b-form-input
            v-model="value"
            v-bind="$attrs"
            :placeholder="placeholder"
            autocomplete="no"
            @keyup.enter="onEnter()"
        ></b-form-input>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: {
        placeholder: {
            type: String,
            default: 'Search',
        },
        clear: {
            type : Boolean,
            default : false
        }
    }, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {
            value: '',
        }
    }, // End of Component > data

    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {
        ...mapGetters(['loading']),
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        value(val) {
            this.setKeyword(val)
        },
        clear(val) {
            this.value=null
        },
    }, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {}, // End of Component > computed

    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {
        setKeyword(val) {
            this.$emit('keyword', val)
        },
        onEnter() {
            this.$parent.reset = new Date().getTime()
            this.$store.commit('setLoading', true)

            // this.loading ? 'disabled' : ''
        },
    }, // End of Component > watch
} // End of export default
</script>
